import {ApiResponse} from "../models/ApiResponse";

export class ApiService {

    apiHeaders = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    };

    /**
     * convert response to api response type.
     * Needed vor json api promises.
     * @param res
     */
    async factoryApiResponse(res: Response): Promise<ApiResponse> {
        return new Promise<ApiResponse>((resolve, reject) => {
            res.json().then(json => {
                let success = true;
                if (res.status !== 200) {
                    success = false;
                }
                resolve(new ApiResponse(success, json));
            }).catch((e) => {
                console.warn(e);
                resolve(new ApiResponse(false, {}));
            });
        });
    }

    /**
     * success promise api call.
     * @param apiResponse
     * @param resolve
     * @param reject
     */
    success(apiResponse: ApiResponse, resolve: Function, reject: Function) {
        if (apiResponse.success) {
            resolve(apiResponse);
        } else {
            reject(apiResponse);
        }
    }

    /**
     * post.
     */
    async post(action: string, data: {}) {
        return new Promise<ApiResponse>((resolve, reject) => {
            fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                headers: this.apiHeaders,
                body: JSON.stringify({
                    action: action,
                    ...data
                })
            }).then(res => this.factoryApiResponse(res)).then((apiResponse: ApiResponse) => {
                this.success(apiResponse, resolve, reject);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

}
